import React from "react";
import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { FaCheck } from "react-icons/fa";
// import { domainExperts } from "./data";
import { StarIcon } from "@heroicons/react/solid";
import { faStarHalfAlt } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { IoMdCheckmarkCircle } from "react-icons/io";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

// Find the domain expert based on the id
// const domainExpert = domainExperts.find((expert) => expert.id === Number(1));

// Function to format the date as 'ddmmyy'
const formatDate = (inputDate) => {
  const date = new Date(inputDate);
  const day = date.getDate().toString().padStart(2, "0");
  const month = new Intl.DateTimeFormat("en-US", { month: "short" }).format(
    date
  );
  return `${day} ${month}`;
};

const BookSession = () => {
  const { sessionId } = useParams();
  const [cardData, setCardData] = useState({});
  const [question, setQuestion] = useState("");
  const [availabilities, setAvailabilities] = useState([]);
  const [questionImage, setQuestionImage] = useState("");
  const [selectedDate, setSelectedDate] = useState("");
  const [selectedTime, setSelectedTimes] = useState("");
  const [showDatePopup, setShowDatePopup] = useState(false);
  const baseUrl = process.env.REACT_APP_BASE_URL;
  const token =
    // localStorage.getItem("EXPERT_AUTH_TOKEN") ||
    localStorage.getItem("USER_AUTH_TOKEN");

  const uniqueDates = [...new Set(availabilities.map((item) => item.date))];

  const handleImageChange = (e) => {
    setQuestionImage(e.target.files[0]);
  };
  const fetchSessionData = async (topic) => {
    try {
      const response = await fetch(`${baseUrl}/api/session/data/${sessionId}`);
      const data = await response.json();

      if (data.status === false && data.error && data.error.message) {
        console.error("Error fetching cards:", data.error.message);
      } else {
        // No error, set the cards data
        console.log("=================================");
        console.log(data);
        setCardData(data.data);
      }
    } catch (error) {
      console.error("Error fetching cards:", error);
    }
  };

  // Getting meetingsData
  const getMeetingsData = async () => {
    try {
      if (cardData && cardData.expertId) {
        const expertId = cardData.expertId;
        const response = await fetch(`${baseUrl}/api/session/${expertId}`, {
          method: "GET",
          headers: {
            Authorization: `${token}`,
          },
        });
        if (response.ok) {
          const data = await response.json();
          console.log(data);
          setAvailabilities(data.data);
        } else {
          console.error("Error fetching meetings data:", response.status);
        }
      } else {
        console.error("cardData.expertId is undefined or null");
      }
    } catch (error) {
      console.error("Error fetching meetings data:", error);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      await fetchSessionData();
    };

    fetchData();
  }, []);

  useEffect(() => {
    // Call getMeetingsData only when cardData is available
    if (cardData && cardData.expertId) {
      getMeetingsData();
    }
  }, [cardData]);

  const handleDateClick = () => {
    setShowDatePopup(true);
  };

  const handleSelectDateClick = (date) => {
    setSelectedDate(date);
    setSelectedTimes("");
  };

  const handleSelectTimeClick = (time) => {
    setSelectedTimes(time);
  };

  const handleSubmit = async (event) => {
    alert("pressed");
    event.preventDefault();
    const headers = new Headers();
    headers.append("Authorization", token);

    const formData = new FormData();
    formData.append("question", question);
    formData.append("questionImage", questionImage);
    formData.append("date", selectedDate);
    formData.append("time", selectedTime);
    formData.append("category", cardData.category);
    formData.append("topic", cardData.topic);
    formData.append("expertId", cardData.expertId);
    formData.append("sessionId", cardData._id);
    alert("working");
    console.log(formData,question);
    const fetchOptions = {
      method: "POST",
      headers: headers,
      body: formData,
    };
    console.log(fetchOptions.body.time);
    try {
      const response = await fetch(
        `${baseUrl}/api/session/booksession`,
        fetchOptions
      );
      console.log('=--------------------------')
      if (response.status === 200) {
        getMeetingsData();
        toast.success("Session Booked", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
      } else if (response.status === 404) {
        toast.error("Something went wrong", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
      }
    } catch (error) {
      console.error("Error:", error);
      toast.error("Internal Server Error: ", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
    }
  };

  const renderHalfStar = () => {
    return (
      <FontAwesomeIcon
        icon={faStarHalfAlt}
        className="w-5 h-5 text-yellow-500"
      />
    );
  };

  return (
    <div>
      <div className="bg-black flex text-white ">
        <div className="my-16 lg:my-40 lg:px-44 px-4">
          <h1 className="text-5xl font-bold">{cardData.topicHeading}</h1>
          <div className="flex items-center mt-5">
            <img
              src="https://cdn-icons-png.flaticon.com/512/3135/3135715.png"
              alt=""
              className="h-10 w-10 mr-5"
            />
            <h2 className="text-3xl">{cardData.expertId?.name || ""}</h2>
          </div>

          <div className="flex mt-5">{cardData.language}</div>
          {/* rating section */}
          <div className="flex">
            {[...Array(5)].map((_, index) => {
              if (index < Math.floor(cardData.ratings)) {
                return (
                  <StarIcon key={index} className="w-4 h-4 text-yellow-500" />
                );
              } else if (
                index === Math.floor(cardData.ratings) &&
                cardData.ratings % 1 !== 0
              ) {
                return renderHalfStar();
              } else {
                return (
                  <StarIcon key={index} className="w-4 h-4 text-gray-300" />
                );
              }
            })}
          </div>
        </div>
      </div>

      <div className=" lg:px-44 px-4 py-20 mb-40flex flex-col">
        {/* Content Div */}
        <div className=" lg:flex space-y-5 lg:space-y-0 lg:space-x-5">
          {/* First Div */}

          <div className=" rounded-2xl shadow-xl border bg-white lg:w-1/2 flex flex-col p-8">
            <h2 className=" text-2xl font-semibold mb-4 text-black">
              Areas Covered
            </h2>
            {cardData.areaCovered && cardData.areaCovered.length > 0 && (
              <ul className="list-disc text-left space-y-2">
                {cardData.areaCovered.map((area, index) => (
                  <li className="text-black flex items-center" key={index}>
                    <IoMdCheckmarkCircle className="text-green-500 mr-2" />
                    {area}
                  </li>
                ))}
              </ul>
            )}
          </div>

          {/* Second Div */}
          <div className=" rounded-2xl shadow-xl border bg-white lg:w-1/2 flex flex-col p-8">
            <h1 className="text-2xl font-semibold mb-4 text-black">
              Ask your question
            </h1>
            <div className="mb-4">
              <textarea
                type="text"
                className="border p-2 rounded-md w-full"
                placeholder="Write your question here"
                value={question}
                onChange={(e) => setQuestion(e.target.value)}
              ></textarea>
              <input
                type="file"
                className="border p-2 rounded-md w-full"
                placeholder="Write your question here"
                onChange={handleImageChange}
              />
              {questionImage && (
                <div>
                  <img
                    src={URL.createObjectURL(questionImage)}
                    alt="SelectedImage"
                    style={{ maxWidth: "100%", maxHeight: "200px" }}
                  />
                </div>
              )}
              {/* {questionImage && (
                <button
                  className="btn btn-primary"
                  onClick={handlePreviewClick}
                >
                  Preview
                </button>
              )} */}
            </div>
            <p className="text-black mb-2">Select Date and Time</p>
            <div className="flex mb-4">
              <button
                className="bg-black text-white px-4 py-2 rounded-md hover:bg-gray-400"
                onClick={handleDateClick}
              >
                Select Slot
              </button>
            </div>
            {selectedDate && selectedTime && (
              <div className="flex flex-col mt-2">
                <div className="flex items-center">
                  <p className="text-black mr-2">Selected Date:</p>
                  <p className="font-semibold">{formatDate(selectedDate)}</p>
                </div>
                <div className="flex items-center">
                  <p className="text-black mr-2">Selected Time:</p>
                  <p className="font-semibold">{selectedTime}</p>
                </div>
              </div>
            )}

            <button
              className={`mt-2 bg-black text-white px-4 py-2 rounded-md hover:bg-green-600 ${
                !token ? "cursor-not-allowed" : ""
              }`}
              onClick={handleSubmit}
              disabled={!token}
            >
              Pay Now
            </button>
          </div>
        </div>

        {showDatePopup && (
          <div className="fixed top-0 left-0 w-full h-full lg:flex justify-center items-center bg-black bg-opacity-50">
            <div className="bg-white p-6 rounded-lg shadow-md lg:w-1/3">
              <h2 className="text-xl font-semibold mb-4">
                Select a Date and Time
              </h2>
              <div className="flex flex-col space-y-2">
                <div className="flex space-x-2 flex-wrap">
                  {uniqueDates.map((date) => (
                    <button
                      key={date}
                      className={`${
                        selectedDate === date
                          ? "text-white bg-blue-500"
                          : " bg-gray-100"
                      }  p-2 rounded-md hover:border-white focus:border-white my-1`}
                      onClick={() => handleSelectDateClick(date)}
                    >
                      {formatDate(date)}
                    </button>
                  ))}
                </div>
                {selectedDate && (
                  <div className="flex space-x-2 flex-wrap mt-2">
                    {availabilities
                      .filter(
                        (availability) => availability.date === selectedDate
                      )
                      .map((availability) => (
                        <button
                          key={availability.id}
                          className={`${
                            selectedTime === availability.time
                              ? "text-white bg-blue-500"
                              : "border-gray-300 bg-gray-100"
                          } p-2 rounded-md hover:border-white focus:border-white my-1`}
                          onClick={() =>
                            handleSelectTimeClick(availability.time)
                          }
                        >
                          {availability.time}
                        </button>
                      ))}
                  </div>
                )}
              </div>

              <button
                className=" text-white bg-black px-4 py-2 rounded-md hover:bg-blue-600 mt-4"
                onClick={() => setShowDatePopup(false)}
              >
                Done
              </button>
            </div>
          </div>
        )}

        {/* third div */}
        <div className=" mt-5 lg:mt-20 lg:flex">
          <div className="rounded-2xl shadow-xl border border-blue-40 bg-white lg:w-1/2 flex flex-col p-8">
            <h2 className="text-xl font-semibold mb-1">Single session</h2>
            <h2 className="text-2xl font-bold my-4 text-center  bg-black text-white px-5 py-3 rounded-lg">
              Rs 29
            </h2>
            {/* <div className="flex flex-col items-center mt-8 mb-5">
              ------------------Or------------------
            </div> */}
            <h2 className="text-xl font-semibold">Monthly Subscription</h2>
            <p className="mb-4">(For best value)</p>
            <ul className="list-disc list-inside mt-4">
              <li className="flex items-center mb-2">
                <FaCheck className="text-green-500 mr-2" />
                10 Sessions
              </li>
              <li className="flex items-center mb-2">
                <FaCheck className="text-green-500 mr-2" />
                No time limit
              </li>
              <li className="flex items-center mb-2">
                <FaCheck className="text-green-500 mr-2" />
                Recorded session
              </li>
              <li className="flex items-center mb-2">
                <FaCheck className="text-green-500 mr-2" />
                Doubt sessions
              </li>
              <li className="flex items-center mb-2">
                <FaCheck className="text-green-500 mr-2" />
                Feedback/Reports
              </li>
            </ul>
            <h2 className="text-2xl font-bold mt-4 text-center  bg-black text-white px-5 py-3 rounded-lg">
              Rs 299
            </h2>
          </div>
          <div className="hidden ml-5 rounded-2xl border border-white bg-white-to-r from-white-100 to-white-200 w-1/2 lg:flex flex-col p-8">
            {/* //empty div to maintain witdth */}
          </div>
        </div>

        {/* Third Div */}
      </div>
    </div>
  );
};

export default BookSession;
